import { CSSObject } from '@chakra-ui/react'

export const containerStyle: CSSObject = {
  w: 'full',
  pt: { base: '64px', md: '96px', lg: '128px' },
  pb: { base: '64px', md: '96px', lg: '128px' },
  px: { base: 4, md: 0 },
  bg: 'gray.50',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

export const headerContainerStyle: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '40px',
  alignSelf: 'stretch',
  mb: '80px',
}

export const itemsWrapperStyle: CSSObject = {
  w: 'full',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: { base: '100px', lg: '120px' },
}

export const tabButtonStyle = (isActive: boolean): CSSObject => ({
  minW: '200px',
  h: '72px',
  py: '18px',
  px: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',

  border: '1px solid',
  borderColor: 'primary.500',
  bg: 'transparent',
  color: 'primary.500',
  borderRadius: '60px',
  fontWeight: 'medium',
  fontSize: '24px',
  transition: 'all 200ms',
  cursor: 'pointer',

  _hover: {
    bg: isActive ? 'primary.600' : 'primary.50',
    borderColor: 'primary.500',
    color: isActive ? 'white' : 'primary.500',
  },
})

export const readMoreButtonStyle: CSSObject = {
  display: 'inline-flex',
  h: '47px',
  py: '10px !important',
  px: '24px !important',
  gap: '8px',
  width: 'fit-content',
  justifyContent: 'center',
  alignItems: 'center',

  color: 'primary.500',
  textAlign: 'center',
  fontFamily: 'Anakotmai',
  fontSize: '18px',
  fontWeight: 'medium',
  lineHeight: '150%',

  border: '1px solid',
  borderColor: 'primary.500',
  bg: 'transparent',
  borderRadius: '60px',

  transition: 'all 200ms',
  textDecoration: 'none',

  _hover: {
    bg: 'primary.50',
    borderColor: 'primary.600',
    color: 'primary.600',
    textDecoration: 'none',
  },

  '& .chakra-button__icon': {
    marginInlineStart: '0 !important',
  },
}

export const registerButtonStyle: CSSObject = {
  display: 'flex',
  h: '72px',
  py: '18px',
  px: '40px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',

  w: { base: 'full', sm: 'auto' },
  minW: '200px',

  color: 'white',
  fontFamily: 'Anakotmai',
  fontSize: '24px',
  fontWeight: 'medium',
  lineHeight: '150%',

  bg: 'primary.500',
  border: '1px solid',
  borderColor: 'primary.500',
  borderRadius: '60px',

  transition: 'all 200ms',
  cursor: 'pointer',
  textDecoration: 'none',

  _hover: {
    bg: 'primary.600',
    borderColor: 'primary.600',
    textDecoration: 'none',
  },
}

export const contentContainerStyle: CSSObject = {
  display: 'flex',
  flexDirection: { base: 'column-reverse', md: 'row' },
  alignItems: 'flex-start',
  gap: { base: '40px', lg: '56px' },
  alignSelf: 'stretch',
  bg: 'transparent',
  p: 0,
}

export const textColumnStyle: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
  gap: { base: '32px', lg: '56px' },
  alignSelf: 'stretch',
  flex: 1,
  w: 'full',
}

export const sectionBoxStyle: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '22px',
  w: 'full',
}

export const imageColumnStyle: CSSObject = {
  flex: 1,
  w: 'full',
  maxW: { md: '534px' },
  alignSelf: { md: 'flex-start' },
}

export const imageWrapperStyle: CSSObject = {
  position: 'relative',
  minH: '320px',
  borderRadius: 'lg',
  overflow: 'hidden',
}

export const priceBoxStyle: CSSObject = {
  position: 'relative',
  isolation: 'isolate',
  overflow: 'hidden',

  p: 6,
  borderRadius: 'lg',
  w: 'full',

  _before: {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    bg: 'primary.50',
    opacity: 0.5,
    zIndex: -1,
  },
}

export const priceTextStyle: CSSObject = {
  fontSize: 'xl',
  fontWeight: 'medium',
  color: 'primary.600',
}

export const priceDetailTextStyle: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'normal',
  color: 'gray.800',
}
